import type { TFeatFlagsState } from './flagTypes';

export const FeatureFlagsDef: TFeatFlagsState = {
  depthPeelingLayers: 0,
  disableTransparencyAngleBasedCompensation: false,
  disableTransparencyFlatCompensation: false,
  mipMapsGaussianBlur: false,
  parallax: false,
  premultipliedAlphaLogos: true,
  wireframeFabrics: false,
};
